import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=dcdfe5fa"
import script from "./CreateModal.vue?vue&type=script&lang=ts"
export * from "./CreateModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateModal.vue?vue&type=style&index=0&id=dcdfe5fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports